import { PureComponent } from "react";
import { Mask } from "antd-mobile";
import "./index.scss"


export default class MiModal extends PureComponent<any, any>{

  constructor(props: any) {
    super(props);
    this.state = {

    }
  }

  submit = () => {
    this.props.onSubmit()
  }


  render() {
    const { visible, setVisible, content, btnStyle } = this.props;
    return (<>
      <Mask visible={visible} onMaskClick={() => setVisible(false)} >
        <div 
          className="Modalbox"
          >
          <div className="Modelcontent">{content}</div>
          <div className="Modal-btn" style={btnStyle}>
            <div onClick={()=>setVisible(false)} className="resetBtn">取消</div>
            <div onClick={this.submit} className="submitBtn">确认</div>
          </div>
        </div>
      </Mask>
    </>)
  }
}